import PartnerList from '../../../Management/partner/partner.List.i18n';
import { VueEditor } from 'vue2-editor'
// import { Api , auth} from '@/service';
import codes from '@/codes';
import vSelect from 'vue-select';
// import CodeEditor from 'simple-code-editor';
import { codemirror } from 'vue-codemirror'
import Mirror from '../Mirror.vue'
// import { javascript } from '@codemirror/lang-javascript'
// import { oneDark } from '@codemirror/theme-one-dark'

import dedent from 'dedent'
// require styles
import 'codemirror/lib/codemirror.css'
// theme css
import 'codemirror/theme/base16-dark.css'

// language
import 'codemirror/mode/vue/vue.js'

// highlightSelectionMatches
import 'codemirror/addon/scroll/annotatescrollbar.js'
import 'codemirror/addon/search/matchesonscrollbar.js'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/search/match-highlighter.js'
// keyMap
import 'codemirror/mode/clike/clike.js'
import 'codemirror/addon/edit/matchbrackets.js'
import 'codemirror/addon/comment/comment.js'
import 'codemirror/addon/dialog/dialog.js'
import 'codemirror/addon/dialog/dialog.css'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/search/search.js'
import 'codemirror/keymap/sublime.js'
// foldGutter
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/brace-fold.js'
import 'codemirror/addon/fold/comment-fold.js'
import 'codemirror/addon/fold/foldcode.js'
import 'codemirror/addon/fold/foldgutter.js'
import 'codemirror/addon/fold/indent-fold.js'
import 'codemirror/addon/fold/markdown-fold.js'
import 'codemirror/addon/fold/xml-fold.js'

//restful api
import { auth } from '@/service'
import { mail as setting } from '@/service/api/setting'
import { mail as common } from '@/service/api/common'
import moment from 'moment-timezone';

export default {
  computed: {
    codemirror() { return this.$refs.CodeMirror }
  },
  components: { vSelect, VueEditor, PartnerList, codemirror, Mirror },
  data : () => {
    return {
      auth,
      lock : false,
      model : {},
      parnter_name : '',
      codes,
      reload : true,
      init : '',
      confirm_remove : false,
      confirm_update : false,
      chainPartner : false,
      syncPartner : false,
      confirm_sample : false,
      sample_model : {

      },
      // codemirror options
      cmOptions: {
        tabSize: 4,
        mode: 'text/html',
        theme: 'base16-dark',
        lineNumbers: true,
        line: true,
      },
      username : '',
    }
  },
  methods: {
    sample_build() {
      this.sample_model = Object.assign({})
      const matches = (this.model.content || '').matchAll(/[M|m]odel.(.\w{0,})/g);

      for (const match of matches) {
        // let tmp = {}
        let v = ''
        let key = match[1]
        if(key == 'time') {
          continue
        }
        else if(key.indexOf('_list') > -1) {
          // 변수 어레이 처리
          this.sample_model[key] = ['test value auto setting']
        } else {
          if(key == 'address') { v = '서울특별시 금천구 가산동 벚꽃로 234' }
          if(key == 'slogan') { v = 'F1-UWSS' }
          if(key == 'domain') { v = location.hostname }
          if(key == 'company') { v = 'f1security' }

          this.sample_model[match[1]] = v
        }

        console.log(match[0], match[1], match.index);
      }

      this.confirm_sample = true;
    },
    async send_sample() {
      try {
        this.username = auth.profile.username

        // let rs = await Api.Manager_Call('mail', 'sample', { model : this.sample_model, cmd : this.model.cmd });
        let rs = await common.commonMail({
          to : this.username, // 본인 메일로 sample mail 발송
          title : this.model.title,
          template : this.model.content,
          model : this.sample_model,
          cmd : this.model.cmd,
          attach_list : [{ cmd : 'sample'}]
        });
        if(!rs.error) {
          this.$toastr.s('Sent', this.$route.name);
          // this.list();
          this.confirm_sample = false
        } else {
          this.$toastr.e('Sent', "failed");
        }
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) , this.list() }
    },
    setPartner(item) {
      this.model.partner = item;
      this.chainPartner = false;
      this.model.partner_id = item.id;
      this.syncPartner = true;
      this.parnter_name = item.username;
      console.log(this.model.partner_id)
      this.$toastr.i("please apply your change", "done")
    },
    refresh(id) {
      this.$router.push({ name: 'mail', params : { id : id ? id : this.model.id } });
    },
    reset() {
      this.model.content = this.init;
    },
    change(content) {
      console.log("changed")
      this.model = Object.assign({}, this.model, { content : content })
    },
    list() { this.$router.push({ name: 'mail'}); this.$emit('refresh'); },
    async get({ id } = this.$route.params) {
      if(id === 'add') { this.add = true; this.lock = false; return; }
      try {
        // let rs = await Api.Manager_Call('mail', 'detail', { id : id });
        let rs = await setting.detailMail({ id : id });
        this.model = Object.assign({ group: {} }, this.model, rs.body)

        this.init = this.model.content;

        this.model.target_list = this.model.target

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) , this.list() }
    },
    async remove() {
      try {
        // let rs = await Api.Manager_Call('mail', 'remove', { id : this.model.id });
        let rs = await setting.deleteMail({ id : this.model.id });
        if(!rs.error) {
          this.$toastr.s('removed', this.$route.name);
          this.list();
        } else {
          this.$toastr.e('Remove', "failed");
        }
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) , this.list() }
    },
    async save() {
      try {
        if(!(this.model.title || '').trim()) { return this.$toastr.e("title", "require") }
        if(!(this.model.content || '').trim()) { return this.$toastr.e("content", "require") }
        if(!this.model.target_list) { return this.$toastr.e("to", "require") }
        if(!this.model.level) { return this.$toastr.e("level", "require") }

        let model = Object.assign({}, this.model, { target : this.model.target_list });
        delete model.partner;

        // if(model.target && typeof '' == typeof model.target) {
        //   model.target = model.target.split(',');
        // }

        // model.target_code = this.model.target_code.meta.value
        // model.category_code = this.model.category_code.meta.value

        // let rs = await Api.Manager_Call('mail', this.model.id ? 'update' : 'insert', model);

        let check_id = '';
        check_id = this.model.id ? 'update' : 'insert'

        if(check_id == 'update'){
          let rs = await setting.updateMail(model);

          if(!rs.error) {
            this.$toastr.s('Saved', this.$route.name);
            if(!this.model.id) { this.refresh(rs.body.id); }
          } else {
            this.$toastr.e('Save', "failed"); this.list();
          }
        }else{
          let rs = await setting.insertMail(model);

          if(!rs.error) {
            this.$toastr.s('Saved', this.$route.name);
            if(!this.model.id) { this.refresh(rs.body.id); }
          } else {
            this.$toastr.e('Save', "failed"); this.list();
          }
        }
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }

      this.lock = true;
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); this.$root.$on('select', this.setPartner) } },
  created: function() { console.log('mail.detail.vue', 'created'); },
  destroyed: function() { console.log('mail.detail.vue', 'destroyed'); },
  mounted: function() { console.log('mail.detail.vue', 'mounted'); this.get(this.$route.params); },
}
